'use client';
import {
  Menubar,
  MenubarMenu,

} from '@/components/ui/menubar';


import NavigationItem from './NavigationItem';
import { NAVIGATION_DATA } from '@/data/defaultValue';



export function Navigation() {

  return (
    <Menubar>
      {NAVIGATION_DATA.map(item => (
        <MenubarMenu key={item.id} >
          <NavigationItem menuItem={item} />
        </MenubarMenu>
      ))}
    </Menubar>
  );
}
